import { Select } from "antd";
import { get, isEmpty } from "lodash";
import { deburredSearch } from "grandus-lib/utils";

const CategoryElementSelectbox = ({
  parameter,
  handleChange,
  selected,
  options = {},
  attributes = {},
}) => {
  const {
    id: parameterId,
    name: parameterName,
    urlTitle: parameterTitle,
  } = parameter;

  const parameterValues = get(parameter, "values", []);

  if (isEmpty(parameterValues)) {
    return "";
  }

  const { styles = {}, headline = "" } = options;

  return (
    <div className={styles?.parameter}>
      {headline ? (
        headline
      ) : (
        <h3 className={styles?.headline}>{parameterName}</h3>
      )}
      <Select
        name={parameterTitle}
        defaultValue={get(selected, [parameterTitle])}
        allowClear={true}
        style={{ width: "100%" }}
        bordered={true}
        onChange={(value) => {
          handleChange(parameterTitle, value);
        }}
        filterOption={(inputValue, option) => {
          return deburredSearch(get(option, "children"), inputValue);
        }}
        {...attributes}
      >
        {parameterValues.map((parameterValue, index) => {
          const parameterValueId = get(
            parameterValue,
            "id",
            encodeURIComponent(parameterValue?.value)
          );
          const parameterValueValue = get(parameterValue, "value");
          const parameterValueTitle = encodeURIComponent(
            get(
              parameterValue,
              "urlName",
              get(parameterValue, "v2-label", parameterValueValue)
            )
          );

          return (
            <Select.Option
              value={parameterValueTitle}
              key={`category-${parameterId}-${parameterValueId}-${index}`}
            >
              {get(parameterValue, "v2-label", parameterValueValue)}
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};

export default CategoryElementSelectbox;
